export const PRODUCT_TAXES = [
    { "label": "Abanico Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Abanico Para Pc ( 14.13% )", "value": "14.13" },
    { "label": "Abrelatas ( 24.3% )", "value": "24.3" },
    { "label": "Abrigo ( 29.95% )", "value": "29.95" },
    { "label": "Accesorio De Camara ( 14.13% )", "value": "14.13" },
    { "label": "Accesorio De Cocina ( 14.13% )", "value": "14.13" },
    { "label": "Accesorio De Cultura Fisica ( 24.3% )", "value": "24.3" },
    { "label": "Accesorio De Fiesta ( 29.95% )", "value": "29.95" },
    { "label": "Accesorio Inflable ( 19.78% )", "value": "19.78" },
    { "label": "Accesorios Musicales ( 19.78% )", "value": "19.78" },
    { "label": "Accesorios Y Partes De Proyector ( 14.13% )", "value": "14.13" },
    { "label": "Acople De Metal ( 19.78% )", "value": "19.78" },
    { "label": "Acordeon ( 24.3% )", "value": "24.3" },
    { "label": "Adaptador Electrico ( 14.13% )", "value": "14.13" },
    { "label": "Adorno ( 29.95% )", "value": "29.95" },
    { "label": "Adorno De Carton ( 14.13% )", "value": "14.13" },
    { "label": "Adorno De Piedra ( 14.3% )", "value": "14.3" },
    { "label": "Agenda De Papel ( 29.95% )", "value": "29.95" },
    { "label": "Agenda Electronica ( 13% )", "value": "13" },
    { "label": "Agujas ( 14.13% )", "value": "14.13" },
    { "label": "Air Bag ( 13% )", "value": "13" },
    { "label": "Aire Acondicionado Para Carro ( 29.95% )", "value": "29.95" },
    { "label": "Alambre De Aluminio ( 14.13% )", "value": "14.13" },
    { "label": "Alambre De Cobre ( 14.13% )", "value": "14.13" },
    { "label": "Alambrina ( 29.95% )", "value": "29.95" },
    { "label": "Alarma ( 14.13% )", "value": "14.13" },
    { "label": "Album ( 19.78% )", "value": "19.78" },
    { "label": "Alcohol En Gel ( 14.13% )", "value": "14.13" },
    { "label": "Alfombra ( 29.95% )", "value": "29.95" },
    { "label": "Alfombra De Carro De Caucho ( 29.95% )", "value": "29.95" },
    { "label": "Alicates ( 14.13% )", "value": "14.13" },
    { "label": "Almohada ( 29.95% )", "value": "29.95" },
    { "label": "Almohadillas Para Tinta ( 19.78% )", "value": "19.78" },
    { "label": "Alternador ( 55.48% )", "value": "55.48" },
    { "label": "Amortiguadores Nuevos ( 42.78% )", "value": "42.78" },
    { "label": "Amortiguadores Usados ( 55.92% )", "value": "55.92" },
    { "label": "Amplificador De Audiofrecuencia ( 14.13% )", "value": "14.13" },
    { "label": "Ampo Metal ( 14.13% )", "value": "14.13" },
    { "label": "Andadera Para Bebe ( 14.13% )", "value": "14.13" },
    { "label": "Antena ( 14.13% )", "value": "14.13" },
    { "label": "Anteojos ( 29.95% )", "value": "29.95" },
    { "label": "Anteojos De Proteccion ( 14.13% )", "value": "14.13" },
    { "label": "Anteojos Para 3d ( 14.13% )", "value": "14.13" },
    { "label": "Anteojos Telescopicos Uso Medico ( 14.13% )", "value": "14.13" },
    { "label": "Antifas Para Dormir ( 29.95% )", "value": "29.95" },
    { "label": "Anzuelo ( 14.13% )", "value": "14.13" },
    { "label": "Aparatos Para Secar Manos ( 29.95% )", "value": "29.95" },
    { "label": "Apoya Cabeza Para Vehiculos ( 13% )", "value": "13" },
    { "label": "Arandelas ( 14.13% )", "value": "14.13" },
    { "label": "Armas ( 29.95% )", "value": "29.95" },
    { "label": "Armas Paintball ( 29.95% )", "value": "29.95" },
    { "label": "Aromatizante Para Carro ( 68.6% )", "value": "68.6" },
    { "label": "Aros Para Carro ( 42.78% )", "value": "42.78" },
    { "label": "Aros Para Motocicleta Y Bicicleta ( 24.3% )", "value": "24.3" },
    { "label": "Arrancador Para Carro ( 42.38% )", "value": "42.38" },
    { "label": "Articulos Inflables ( 19.78% )", "value": "19.78" },
    { "label": "Asador De Gas ( 24.3% )", "value": "24.3" },
    { "label": "Aseo Personal ( 29.9% )", "value": "29.9" },
    { "label": "Asiento Para Motocicleta Y Bicicleta ( 14.13% )", "value": "14.13" },
    { "label": "Asientos Para Carro ( 24.3% )", "value": "24.3" },
    { "label": "Aspiradora ( 49.27% )", "value": "49.27" },
    { "label": "Audifono  ( 14.13% )", "value": "14.13" },
    { "label": "Audifono Para No Oyentes ( 1% )", "value": "1" },
    { "label": "Balastro ( 14.13% )", "value": "14.13" },
    { "label": "Banda Transportadora ( 14.13% )", "value": "14.13" },
    { "label": "Bandas Para Test ( 14.13% )", "value": "14.13" },
    { "label": "Bandas Reflectiva Seguridad ( 14.13% )", "value": "14.13" },
    { "label": "Banderas De Tela ( 29.95% )", "value": "29.95" },
    { "label": "Barra De Cobre ( 29.95% )", "value": "29.95" },
    { "label": "Barra De Hierro ( 19.78% )", "value": "19.78" },
    { "label": "Bascula Para Pesar Personas ( 19.78% )", "value": "19.78" },
    { "label": "Base De Metal ( 14.13% )", "value": "14.13" },
    { "label": "Base Plastica ( 29.95% )", "value": "29.95" },
    { "label": "Baston ( 29.95% )", "value": "29.95" },
    { "label": "Bateria Acustica ( 24.3% )", "value": "24.3" },
    { "label": "Bateria Laptop  ( 42.38% )", "value": "42.38" },
    { "label": "Bateria Recargable ( 42.38% )", "value": "42.38" },
    { "label": "Batidora ( 49.27% )", "value": "49.27" },
    { "label": "Binchas Y Colas Para Cabello ( 29.95% )", "value": "29.95" },
    { "label": "Binoculares ( 29.95% )", "value": "29.95" },
    { "label": "Bisagrapara Puerta ( 24.3% )", "value": "24.3" },
    { "label": "Bisuteria ( 29.95% )", "value": "29.95" },
    { "label": "Blusas ( 29.95% )", "value": "29.95" },
    { "label": "Bobina Electrica ( 14.13% )", "value": "14.13" },
    { "label": "Bola De Futbol ( 24.3% )", "value": "24.3" },
    { "label": "Bolas De Golf ( 24.3% )", "value": "24.3" },
    { "label": "Bolas De Tennis ( 24.3% )", "value": "24.3" },
    { "label": "Bolillos Para Tambor ( 19.78% )", "value": "19.78" },
    { "label": "Bolsa De Papel ( 24.3% )", "value": "24.3" },
    { "label": "Bolsa Plastica ( 24.3% )", "value": "24.3" },
    { "label": "Bomba De Aceite ( 14.13% )", "value": "14.13" },
    { "label": "Bomba De Agua ( 14.13% )", "value": "14.13" },
    { "label": "Bomba De Aire ( 14.13% )", "value": "14.13" },
    { "label": "Bomba De Aire Manual ( 14.13% )", "value": "14.13" },
    { "label": "Bomba De Vacio ( 14.13% )", "value": "14.13" },
    { "label": "Bombillos ( 19.78% )", "value": "19.78" },
    { "label": "Booster ( 13% )", "value": "13" },
    { "label": "Borrador ( 10% )", "value": "10" },
    { "label": "Botas De Hule ( 29.95% )", "value": "29.95" },
    { "label": "Bote Inflable ( 19.78% )", "value": "19.78" },
    { "label": "Botiquin  Primeros Auxilios ( 14.13% )", "value": "14.13" },
    { "label": "Botones De Metal ( 19.78% )", "value": "19.78" },
    { "label": "Botones De Plastico ( 19.78% )", "value": "19.78" },
    { "label": "Boxer De Algodon Y De Punto ( 29.95% )", "value": "29.95" },
    { "label": "Brassier ( 29.95% )", "value": "29.95" },
    { "label": "Brazalettes Adhesivos ( 29.95% )", "value": "29.95" },
    { "label": "Brocas ( 14.13% )", "value": "14.13" },
    { "label": "Brocha Para Pintar ( 29.95% )", "value": "29.95" },
    { "label": "Brochas De Maquillaje ( 19.78% )", "value": "19.78" },
    { "label": "Brujulas  ( 1% )", "value": "1" },
    { "label": "Bufanda ( 29.95% )", "value": "29.95" },
    { "label": "Bujias ( 42.38% )", "value": "42.38" },
    { "label": "Bumper ( 42.78% )", "value": "42.78" },
    { "label": "Bushing Metaloplastica ( 19.78% )", "value": "19.78" },
    { "label": "Cable Coaxial ( 19.78% )", "value": "19.78" },
    { "label": "Cable Coaxial Para Antena ( 19.78% )", "value": "19.78" },
    { "label": "Cable De Metal ( 14.13% )", "value": "14.13" },
    { "label": "Cable Para Audio ( 14.13% )", "value": "14.13" },
    { "label": "Cables Electrico ( 19.78% )", "value": "19.78" },
    { "label": "Cables Para Bujias ( 19.78% )", "value": "19.78" },
    { "label": "Cadena ( 14.13% )", "value": "14.13" },
    { "label": "Caja Breaker ( 14.13% )", "value": "14.13" },
    { "label": "Caja Carton ( 24.3% )", "value": "24.3" },
    { "label": "Caja De Metal  ( 14.13% )", "value": "14.13" },
    { "label": "Caja De Musica ( 24.3% )", "value": "24.3" },
    { "label": "Caja Fuerte ( 29.95% )", "value": "29.95" },
    { "label": "Caja Registradora ( 13% )", "value": "13" },
    { "label": "Cajas De Cambio Nuevas ( 24.3% )", "value": "24.3" },
    { "label": "Cajas De Cambio Usadas ( 24.63% )", "value": "24.63" },
    { "label": "Cajas De Joyeria De Madera ( 29.95% )", "value": "29.95" },
    { "label": "Calcomanias ( 24.3% )", "value": "24.3" },
    { "label": "Calculadora ( 13% )", "value": "13" },
    { "label": "Calendario ( 29.95% )", "value": "29.95" },
    { "label": "Calentador De Agua Electrico ( 68.6% )", "value": "68.6" },
    { "label": "Calentador De Agua No Electrico ( 24.3% )", "value": "24.3" },
    { "label": "Calzoncillo ( 29.95% )", "value": "29.95" },
    { "label": "Calzones ( 29.95% )", "value": "29.95" },
    { "label": "Camara De Video ( 14.13% )", "value": "14.13" },
    { "label": "Camara Digital ( 13% )", "value": "13" },
    { "label": "Camara Fotografica ( 13% )", "value": "13" },
    { "label": "Camara Para Compu ( 13% )", "value": "13" },
    { "label": "Caminadora ( 24.3% )", "value": "24.3" },
    { "label": "Camisa ( 29.95% )", "value": "29.95" },
    { "label": "Camiseta ( 29.95% )", "value": "29.95" },
    { "label": "Candado ( 19.78% )", "value": "19.78" },
    { "label": "Candela Decorativa ( 29.95% )", "value": "29.95" },
    { "label": "Candelabro ( 14.13% )", "value": "14.13" },
    { "label": "Canela En Polvo ( 14.13% )", "value": "14.13" },
    { "label": "Capa Impermeable  ( 29.95% )", "value": "29.95" },
    { "label": "Carbones ( 14.13% )", "value": "14.13" },
    { "label": "Cargador Electricos ( 14.13% )", "value": "14.13" },
    { "label": "Carrete De Pesca ( 14.13% )", "value": "14.13" },
    { "label": "Carroceria  De Carro  ( 42.78% )", "value": "42.78" },
    { "label": "Carton De Bingo ( 29.95% )", "value": "29.95" },
    { "label": "Casco De Moto ( 13% )", "value": "13" },
    { "label": "Cascos De Seguridad ( 29.95% )", "value": "29.95" },
    { "label": "Cassette De Video ( 13% )", "value": "13" },
    { "label": "Catalogos ( 29.95% )", "value": "29.95" },
    { "label": "Cd ( 24.3% )", "value": "24.3" },
    { "label": "Celular ( 13% )", "value": "13" },
    { "label": "Cepillo De Dientes ( 15% )", "value": "15" },
    { "label": "Cepillo Dientes Electrico ( 1% )", "value": "1" },
    { "label": "Cepillo Electrico Para Cabello ( 1% )", "value": "1" },
    { "label": "Cepillos Con Mango  ( 29.95% )", "value": "29.95" },
    { "label": "Cera Para Carro ( 29.95% )", "value": "29.95" },
    { "label": "Cercas De Alambre ( 10% )", "value": "10" },
    { "label": "Certificado ( 15% )", "value": "15" },
    { "label": "Chaleco Antibalas ( 29.95% )", "value": "29.95" },
    { "label": "Chaleco Reflectivo ( 13% )", "value": "13" },
    { "label": "Chaleco Salvavidas ( 14.13% )", "value": "14.13" },
    { "label": "Chapiadora ( 14.13% )", "value": "14.13" },
    { "label": "Cheque ( 15% )", "value": "15" },
    { "label": "Chequera ( 15% )", "value": "15" },
    { "label": "Chips ( 13% )", "value": "13" },
    { "label": "Chupetas ( 24.3% )", "value": "24.3" },
    { "label": "Chupones ( 29.95% )", "value": "29.95" },
    { "label": "Cierre Puertas Automaticas ( 14.13% )", "value": "14.13" },
    { "label": "Cigarros Electricos ( 14.13% )", "value": "14.13" },
    { "label": "Cinta Adhesiva ( 24.3% )", "value": "24.3" },
    { "label": "Cinta De Nylon ( 24.3% )", "value": "24.3" },
    { "label": "Cinta Metrica ( 14.13% )", "value": "14.13" },
    { "label": "Cinta O Cartucho Para Impresora ( 19.78% )", "value": "19.78" },
    { "label": "Cinta Para Decorar ( 24.3% )", "value": "24.3" },
    { "label": "Cinta Reflectiva Tela ( 14.13% )", "value": "14.13" },
    { "label": "Cintas Reflectivas De Vehiculo ( 13% )", "value": "13" },
    { "label": "Cinturon ( 13% )", "value": "13" },
    { "label": "Cinturon Seguridad Moto ( 13% )", "value": "13" },
    { "label": "Clavijas Guitarra ( 19.78% )", "value": "19.78" },
    { "label": "Clavos ( 10% )", "value": "10" },
    { "label": "Clips Para Oficina ( 29.95% )", "value": "29.95" },
    { "label": "Cobertor De Cama ( 29.95% )", "value": "29.95" },
    { "label": "Cobertor De Tela ( 29.95% )", "value": "29.95" },
    { "label": "Cobija ( 29.95% )", "value": "29.95" },
    { "label": "Cobija Electrica ( 29.95% )", "value": "29.95" },
    { "label": "Coche ( 29.95% )", "value": "29.95" },
    { "label": "Cocina Electrica ( 42.83% )", "value": "42.83" },
    { "label": "Cocina Portatil ( 29.95% )", "value": "29.95" },
    { "label": "Coffemaker ( 49.27% )", "value": "49.27" },
    { "label": "Colas Y Demas Adhesivps Prep ( 29.95% )", "value": "29.95" },
    { "label": "Colchas ( 29.95% )", "value": "29.95" },
    { "label": "Colchon ( 29.95% )", "value": "29.95" },
    { "label": "Colchon Inflable ( 29.95% )", "value": "29.95" },
    { "label": "Collar Para Perro Con Sensor ( 14.13% )", "value": "14.13" },
    { "label": "Columna Para Volante De Direccion Para Carro ( 24.3% )", "value": "24.3" },
    { "label": "Compas ( 1% )", "value": "1" },
    { "label": "Compresor ( 14.13% )", "value": "14.13" },
    { "label": "Computadora ( 13% )", "value": "13" },
    { "label": "Conector Electrico ( 13% )", "value": "13" },
    { "label": "Conector Manguera Plastica ( 19.78% )", "value": "19.78" },
    { "label": "Confites ( 29.95% )", "value": "29.95" },
    { "label": "Consola De Audio ( 24.3% )", "value": "24.3" },
    { "label": "Consola De Video Juego ( 55.71% )", "value": "55.71" },
    { "label": "Contestadora De Telefono ( 29.95% )", "value": "29.95" },
    { "label": "Contestadora Telefonica ( 29.95% )", "value": "29.95" },
    { "label": "Control De Juego Video ( 55.71% )", "value": "55.71" },
    { "label": "Control De Tv ( 14.13% )", "value": "14.13" },
    { "label": "Control Universal ( 14.13% )", "value": "14.13" },
    { "label": "Convertidor De Voz Imagen Y Sonido ( 13% )", "value": "13" },
    { "label": "Convertidor Electrico Para Motor ( 13% )", "value": "13" },
    { "label": "Cooler Para Pc  ( 13% )", "value": "13" },
    { "label": "Corbatas ( 29.95% )", "value": "29.95" },
    { "label": "Cordones ( 29.95% )", "value": "29.95" },
    { "label": "Correa Transportadora De Tela ( 14.13% )", "value": "14.13" },
    { "label": "Cortadora De Papel Electrico ( 14.13% )", "value": "14.13" },
    { "label": "Cortadora De Papel Manual ( 29.95% )", "value": "29.95" },
    { "label": "Cortadora De Punto ( 14.13% )", "value": "14.13" },
    { "label": "Cortadora De Zacate  ( 14.13% )", "value": "14.13" },
    { "label": "Cortinas ( 29.95% )", "value": "29.95" },
    { "label": "Cpu ( 13% )", "value": "13" },
    { "label": "Crayones ( 10% )", "value": "10" },
    { "label": "Cremas O Maquillaje ( 29.95% )", "value": "29.95" },
    { "label": "Cronometros ( 14.13% )", "value": "14.13" },
    { "label": "Cuaderno ( 15% )", "value": "15" },
    { "label": "Cuadro Fotos ( 29.95% )", "value": "29.95" },
    { "label": "Cubo Para Roscar ( 14.13% )", "value": "14.13" },
    { "label": "Cuchillas ( 19.78% )", "value": "19.78" },
    { "label": "Cuchillas Para Maquinas ( 1% )", "value": "1" },
    { "label": "Cuchillos Para Podar ( 6% )", "value": "6" },
    { "label": "Cuerda De Nylon ( 14.13% )", "value": "14.13" },
    { "label": "Cuerda De Pescar ( 19.78% )", "value": "19.78" },
    { "label": "Cuerdas De Guitarra Acustica ( 19.78% )", "value": "19.78" },
    { "label": "Cuerdas De Guitarra Electrica ( 19.78% )", "value": "19.78" },
    { "label": "Cuna ( 29.95% )", "value": "29.95" },
    { "label": "Desechos De Caucho ( 14.13% )", "value": "14.13" },
    { "label": "Diodos ( 13% )", "value": "13" },
    { "label": "Disco Abrasivo ( 19.78% )", "value": "19.78" },
    { "label": "Disco De Acetato ( 29.95% )", "value": "29.95" },
    { "label": "Disco De Asbesto ( 19.78% )", "value": "19.78" },
    { "label": "Disco De Musica ( 24.3% )", "value": "24.3" },
    { "label": "Disco Duro Externo ( 13% )", "value": "13" },
    { "label": "Disco Duro Interno ( 13% )", "value": "13" },
    { "label": "Discos Programas Para Pc ( 14.13% )", "value": "14.13" },
    { "label": "Dispensador De Agua Electrico ( 14.13% )", "value": "14.13" },
    { "label": "Dispensador De Cintas ( 29.95% )", "value": "29.95" },
    { "label": "Distriduidor Para Carro ( 42.38% )", "value": "42.38" },
    { "label": "Documentos Personales ( 1% )", "value": "1" },
    { "label": "Ducha Metal Cromado ( 29.95% )", "value": "29.95" },
    { "label": "Ducha Plastica ( 29.95% )", "value": "29.95" },
    { "label": "Dvd Juegos  ( 13% )", "value": "13" },
    { "label": "Dvd Peliculas ( 14.13% )", "value": "14.13" },
    { "label": "Dvd Reproductor ( 49.27% )", "value": "49.27" },
    { "label": "Ecualizador ( 13% )", "value": "13" },
    { "label": "Eje De Carro ( 42.78% )", "value": "42.78" },
    { "label": "Ejes Con Diferencial ( 42.78% )", "value": "42.78" },
    { "label": "Electrodos ( 29.95% )", "value": "29.95" },
    { "label": "Emanadores Para Insectos ( 29.95% )", "value": "29.95" },
    { "label": "Emblemas Para Carro ( 19.78% )", "value": "19.78" },
    { "label": "Embragues Y Acoples De Carro  ( 14.13% )", "value": "14.13" },
    { "label": "Empaque De Plastico ( 19.78% )", "value": "19.78" },
    { "label": "Empaques De Metal ( 19.78% )", "value": "19.78" },
    { "label": "Empaques Hule ( 19.78% )", "value": "19.78" },
    { "label": "Emplasticadora ( 24.3% )", "value": "24.3" },
    { "label": "Enaguas ( 29.95% )", "value": "29.95" },
    { "label": "Encendedores ( 29.95% )", "value": "29.95" },
    { "label": "Enceradora De Pisos Electrica  ( 49.27% )", "value": "49.27" },
    { "label": "Engranaje ( 14.13% )", "value": "14.13" },
    { "label": "Equipo De Diagnostico Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Equipo De Medicion ( 14.13% )", "value": "14.13" },
    { "label": "Equipo De Medicion Presion ( 13% )", "value": "13" },
    { "label": "Equipo De Meteorologia ( 14.13% )", "value": "14.13" },
    { "label": "Equipo De Meteorologia Agropecuario ( 1% )", "value": "1" },
    { "label": "Equipo De Sonido ( 49.27% )", "value": "49.27" },
    { "label": "Equipo De Topografia ( 14.13% )", "value": "14.13" },
    { "label": "Equipo Para Estudio Fotografico ( 14.13% )", "value": "14.13" },
    { "label": "Escalera De Aluminio ( 24.3% )", "value": "24.3" },
    { "label": "Escobillas De Carro ( 19.78% )", "value": "19.78" },
    { "label": "Espatula ( 24.3% )", "value": "24.3" },
    { "label": "Espejo ( 29.95% )", "value": "29.95" },
    { "label": "Esponja Para Uso Domestico ( 29.95% )", "value": "29.95" },
    { "label": "Esposas ( 14.13% )", "value": "14.13" },
    { "label": "Espuma ( 29.95% )", "value": "29.95" },
    { "label": "Esquiladora ( 10% )", "value": "10" },
    { "label": "Estampillas De Coleccion ( 29.95% )", "value": "29.95" },
    { "label": "Estereofon ( 14.13% )", "value": "14.13" },
    { "label": "Esterilizadores ( 14.13% )", "value": "14.13" },
    { "label": "Estetoscopio ( 14.13% )", "value": "14.13" },
    { "label": "Estuche Para Celular ( 29.95% )", "value": "29.95" },
    { "label": "Estufa Portatil ( 24.3% )", "value": "24.3" },
    { "label": "Etiquetas ( 29.95% )", "value": "29.95" },
    { "label": "Evilla De Faja ( 14.13% )", "value": "14.13" },
    { "label": "Extractor De Grasa ( 14.13% )", "value": "14.13" },
    { "label": "Extractor De Jugos De Frutas   ( 49.27% )", "value": "49.27" },
    { "label": "Faja De Transmision ( 14.13% )", "value": "14.13" },
    { "label": "Fajas ( 29.95% )", "value": "29.95" },
    { "label": "Fax ( 13% )", "value": "13" },
    { "label": "Fibra De Vidrio ( 14.13% )", "value": "14.13" },
    { "label": "Fibras De Freno   ( 42.78% )", "value": "42.78" },
    { "label": "Fieltro Papel ( 14% )", "value": "14" },
    { "label": "Filtro De Aceite ( 24.3% )", "value": "24.3" },
    { "label": "Filtro De Agua ( 14.13% )", "value": "14.13" },
    { "label": "Filtro De Aire ( 24.3% )", "value": "24.3" },
    { "label": "Flejes De Navaja ( 14.13% )", "value": "14.13" },
    { "label": "Fluorescente ( 29.95% )", "value": "29.95" },
    { "label": "Foco ( 19.78% )", "value": "19.78" },
    { "label": "Focos Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Foil ( 24.3% )", "value": "24.3" },
    { "label": "Folder ( 29.95% )", "value": "29.95" },
    { "label": "Fotocopiadora ( 14.13% )", "value": "14.13" },
    { "label": "Fotografia ( 29.95% )", "value": "29.95" },
    { "label": "Freidora ( 49.27% )", "value": "49.27" },
    { "label": "Frenos De Bicicleta ( 13% )", "value": "13" },
    { "label": "Frenos De Moto ( 13% )", "value": "13" },
    { "label": "Frenos Y Sus Partes Carro ( 42.78% )", "value": "42.78" },
    { "label": "Fuente De Chocolate  ( 49.27% )", "value": "49.27" },
    { "label": "Fusible ( 14.13% )", "value": "14.13" },
    { "label": "Gancho Ropa De Metal ( 14.13% )", "value": "14.13" },
    { "label": "Gancho Ropa Plastico  ( 29.95% )", "value": "29.95" },
    { "label": "Gata Hidraulica ( 14.13% )", "value": "14.13" },
    { "label": "Gata Mecanica  ( 14.13% )", "value": "14.13" },
    { "label": "Generador De Corriente ( 14.13% )", "value": "14.13" },
    { "label": "Globo Terraqueo ( 14.13% )", "value": "14.13" },
    { "label": "Goma Y Demas Adhesivos Preparados ( 29.95% )", "value": "29.95" },
    { "label": "Gorra ( 29.95% )", "value": "29.95" },
    { "label": "Gps ( 19.78% )", "value": "19.78" },
    { "label": "Grabador De Video ( 49.27% )", "value": "49.27" },
    { "label": "Grabadora De Voz ( 49.27% )", "value": "49.27" },
    { "label": "Griferia De Metal Cromado ( 29.95% )", "value": "29.95" },
    { "label": "Griferia De Plastico Cromado ( 14.13% )", "value": "14.13" },
    { "label": "Guantes De Caucho ( 29.95% )", "value": "29.95" },
    { "label": "Guantes De Cuero ( 24.3% )", "value": "24.3" },
    { "label": "Guantes De Plastico ( 15% )", "value": "15" },
    { "label": "Guarnicion Para Carroceria ( 24.3% )", "value": "24.3" },
    { "label": "Guitarra Acustica ( 29.95% )", "value": "29.95" },
    { "label": "Guitarra Electrica ( 24.3% )", "value": "24.3" },
    { "label": "Hamacas ( 29.95% )", "value": "29.95" },
    { "label": "Helice Para Barco ( 14.13% )", "value": "14.13" },
    { "label": "Herramienta Electrica ( 14.13% )", "value": "14.13" },
    { "label": "Herramienta Manual ( 14.13% )", "value": "14.13" },
    { "label": "Herramienta Neumatica O Hidraulica Manual ( 14.13% )", "value": "14.13" },
    { "label": "Herramientas Jardin ( 1% )", "value": "1" },
    { "label": "Hielera ( 29.95% )", "value": "29.95" },
    { "label": "Hilo De Coser Para La Venta Al Por Menor ( 19.78% )", "value": "19.78" },
    { "label": "Hojas De Sierras Para Trabajar Metal ( 14.13% )", "value": "14.13" },
    { "label": "Hometheater ( 49.27% )", "value": "49.27" },
    { "label": "Horma Para Calzado ( 14.13% )", "value": "14.13" },
    { "label": "Horno  Domestico ( 42.83% )", "value": "42.83" },
    { "label": "Horno Microondas ( 37.58% )", "value": "37.58" },
    { "label": "Horno Tostadror ( 49.27% )", "value": "49.27" },
    { "label": "Horquillas Para Bicicleta ( 24.3% )", "value": "24.3" },
    { "label": "Humificador ( 14.13% )", "value": "14.13" },
    { "label": "Identificador De Llamadas ( 13% )", "value": "13" },
    { "label": "Imanes ( 14.13% )", "value": "14.13" },
    { "label": "Impreso Publicitario ( 29.95% )", "value": "29.95" },
    { "label": "Impresora De Etiquetas ( 29.95% )", "value": "29.95" },
    { "label": "Impresora Multifuncional ( 13% )", "value": "13" },
    { "label": "Impresos Publicitarios ( 29.95% )", "value": "29.95" },
    { "label": "Incubadora ( 1% )", "value": "1" },
    { "label": "Inflable Para Cultura Fisica ( 24.3% )", "value": "24.3" },
    { "label": "Instrumento Musical ( 24.3% )", "value": "24.3" },
    { "label": "Instrumentos De Geodesia ( 14.13% )", "value": "14.13" },
    { "label": "Interruptores Electricos De Contacto ( 13% )", "value": "13" },
    { "label": "Inyectores De Carro ( 14.13% )", "value": "14.13" },
    { "label": "Ipads ( 13% )", "value": "13" },
    { "label": "Iphone ( 13% )", "value": "13" },
    { "label": "Ipod ( 49.27% )", "value": "49.27" },
    { "label": "Ipod Mp3 ( 49.27% )", "value": "49.27" },
    { "label": "Ipod Mp4 ( 49.27% )", "value": "49.27" },
    { "label": "Jabon Liquido Para Manos ( 49.27% )", "value": "49.27" },
    { "label": "Jabon Para Ropa ( 29.95% )", "value": "29.95" },
    { "label": "Jaulas Metalicas ( 24.3% )", "value": "24.3" },
    { "label": "Jaulas Plasticas ( 24.3% )", "value": "24.3" },
    { "label": "Joyeria ( 29.95% )", "value": "29.95" },
    { "label": "Juego De Video En Cd  ( 13% )", "value": "13" },
    { "label": "Juegos De Mesa ( 29.95% )", "value": "29.95" },
    { "label": "Juguete ( 29.95% )", "value": "29.95" },
    { "label": "Juguete Reducidos A Escala ( 29.95% )", "value": "29.95" },
    { "label": "Lampara Fluorescente ( 14.13% )", "value": "14.13" },
    { "label": "Lamparas De Mesa ( 29.95% )", "value": "29.95" },
    { "label": "Lana ( 19.78% )", "value": "19.78" },
    { "label": "Lapiceros ( 29.95% )", "value": "29.95" },
    { "label": "Lapices ( 10% )", "value": "10" },
    { "label": "Lapices De Color ( 10% )", "value": "10" },
    { "label": "Lapiz De Minas ( 14.13% )", "value": "14.13" },
    { "label": "Laptop ( 13% )", "value": "13" },
    { "label": "Lavadora ( 42.83% )", "value": "42.83" },
    { "label": "Lavadora Con Secador ( 42.83% )", "value": "42.83" },
    { "label": "Lavatorio De Ceramica ( 29.95% )", "value": "29.95" },
    { "label": "Lector Optico ( 14.13% )", "value": "14.13" },
    { "label": "Legos ( 29.95% )", "value": "29.95" },
    { "label": "Lente De Camara ( 14.13% )", "value": "14.13" },
    { "label": "Lente De Contacto ( 19.78% )", "value": "19.78" },
    { "label": "Lentes ( 29.95% )", "value": "29.95" },
    { "label": "Libros  ( 1% )", "value": "1" },
    { "label": "Licuadora ( 49% )", "value": "49" },
    { "label": "Lija En Lamina Para Madera ( 24.3% )", "value": "24.3" },
    { "label": "Lijadora ( 14.13% )", "value": "14.13" },
    { "label": "Limas  ( 24.3% )", "value": "24.3" },
    { "label": "Limpia Parabrisas ( 19.78% )", "value": "19.78" },
    { "label": "Limpiador De Discos ( 14.13% )", "value": "14.13" },
    { "label": "Limpiador De Pisos Electrico  ( 49.27% )", "value": "49.27" },
    { "label": "Link ( 14.13% )", "value": "14.13" },
    { "label": "Llanta ( 19.78% )", "value": "19.78" },
    { "label": "Llave Maya ( 13% )", "value": "13" },
    { "label": "Llavero ( 29.95% )", "value": "29.95" },
    { "label": "Llaves De Puerta U Otras ( 19.78% )", "value": "19.78" },
    { "label": "Llavin Puerta De Carro ( 14.13% )", "value": "14.13" },
    { "label": "Llavines ( 14.13% )", "value": "14.13" },
    { "label": "Lubricante De Carro ( 14.13% )", "value": "14.13" },
    { "label": "Lubricante Sexual ( 14.13% )", "value": "14.13" },
    { "label": "Luces De Carro ( 19.78% )", "value": "19.78" },
    { "label": "Luces De Navidad  ( 29.95% )", "value": "29.95" },
    { "label": "Lupa ( 14.13% )", "value": "14.13" },
    { "label": "Luz Led ( 14.13% )", "value": "14.13" },
    { "label": "Malla Para Pesca ( 6% )", "value": "6" },
    { "label": "Malla Sintetica ( 19.78% )", "value": "19.78" },
    { "label": "Manguera ( 19.78% )", "value": "19.78" },
    { "label": "Maniquies ( 29.95% )", "value": "29.95" },
    { "label": "Manivelas De Moto ( 24.3% )", "value": "24.3" },
    { "label": "Manteles ( 29.95% )", "value": "29.95" },
    { "label": "Manufactira De Latex De Hule ( 14.13% )", "value": "14.13" },
    { "label": "Manufactura De Aluminio ( 24% )", "value": "24" },
    { "label": "Manufactura De Caucho ( 19% )", "value": "19" },
    { "label": "Manufactura De Ceramica ( 29.95% )", "value": "29.95" },
    { "label": "Manufactura De Hule ( 19% )", "value": "19" },
    { "label": "Manufactura De Madera ( 29% )", "value": "29" },
    { "label": "Manufactura De Porcelana ( 29.95% )", "value": "29.95" },
    { "label": "Manufactura De Vidrio ( 29.95% )", "value": "29.95" },
    { "label": "Manufactura Metalica ( 14% )", "value": "14" },
    { "label": "Manufactura Papel Y Carton ( 24.3% )", "value": "24.3" },
    { "label": "Manufactura Plastica ( 29.95% )", "value": "29.95" },
    { "label": "Mapas ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Contadora De Monedas Y Billetes ( 14.13% )", "value": "14.13" },
    { "label": "Maquina De Coser ( 14.13% )", "value": "14.13" },
    { "label": "Maquina De Hacer Niebla ( 14.13% )", "value": "14.13" },
    { "label": "Maquina De Hacer Palomitas ( 14.13% )", "value": "14.13" },
    { "label": "Maquina De Lavado A Presion ( 14.13% )", "value": "14.13" },
    { "label": "Maquina De Soldar ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Limpiadora Por Ionizacion ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Mezcladora De Cerveza ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Para Copiar Llaves ( 24.3% )", "value": "24.3" },
    { "label": "Maquina Para Manicure ( 24.3% )", "value": "24.3" },
    { "label": "Maquina Para Registrar Asistencia ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Que Opere Mediante Laser O Haces De Luz ( 14.13% )", "value": "14.13" },
    { "label": "Maquina Y Aparato En Uso Textil ( 14.13% )", "value": "14.13" },
    { "label": "Marco De Fotos Digital ( 14.13% )", "value": "14.13" },
    { "label": "Marco De Madera Para Pintura ( 29.95% )", "value": "29.95" },
    { "label": "Marco Para Bicilceta ( 24.3% )", "value": "24.3" },
    { "label": "Marco Para Fotografias ( 29.95% )", "value": "29.95" },
    { "label": "Mascara De Soldar ( 29.95% )", "value": "29.95" },
    { "label": "Mascara Para Dormir ( 29.9% )", "value": "29.9" },
    { "label": "Mascarilla De Plastico ( 14.13% )", "value": "14.13" },
    { "label": "Mascarillas Desechables Tela ( 14.13% )", "value": "14.13" },
    { "label": "Material Educativo  ( 6% )", "value": "6" },
    { "label": "Mecate ( 29.95% )", "value": "29.95" },
    { "label": "Mecha De Piso ( 15% )", "value": "15" },
    { "label": "Medias ( 29.95% )", "value": "29.95" },
    { "label": "Medidor De Humedad  ( 1% )", "value": "1" },
    { "label": "Medidor De Presion ( 13% )", "value": "13" },
    { "label": "Medidor De Radiaciones Ionicas ( 14.13% )", "value": "14.13" },
    { "label": "Membrana Plastica ( 29.95% )", "value": "29.95" },
    { "label": "Memory Stick ( 13% )", "value": "13" },
    { "label": "Microfono ( 14.13% )", "value": "14.13" },
    { "label": "Microscopio ( 14.13% )", "value": "14.13" },
    { "label": "Mixer ( 49.27% )", "value": "49.27" },
    { "label": "Modem ( 14.13% )", "value": "14.13" },
    { "label": "Moldes De Metal ( 14.13% )", "value": "14.13" },
    { "label": "Monedas ( 19.78% )", "value": "19.78" },
    { "label": "Monitor ( 13% )", "value": "13" },
    { "label": "Montura Para Caballo ( 29.95% )", "value": "29.95" },
    { "label": "Motor  Electrico ( 14.13% )", "value": "14.13" },
    { "label": "Motor Diesel ( 14.13% )", "value": "14.13" },
    { "label": "Motor Gasolina ( 14.13% )", "value": "14.13" },
    { "label": "Mousepad ( 29.95% )", "value": "29.95" },
    { "label": "Mueble De Madera ( 29.95% )", "value": "29.95" },
    { "label": "Mueble De Metal ( 29.95% )", "value": "29.95" },
    { "label": "Mueble De Plastico ( 29.95% )", "value": "29.95" },
    { "label": "Mueble De Vidrio ( 29.45% )", "value": "29.45" },
    { "label": "Mufla ( 42.78% )", "value": "42.78" },
    { "label": "Multimetros ( 14.13% )", "value": "14.13" },
    { "label": "Naipes ( 29.95% )", "value": "29.95" },
    { "label": "Neomaticos De Bicicleta ( 14.13% )", "value": "14.13" },
    { "label": "Neomaticos De Carro ( 19.78% )", "value": "19.78" },
    { "label": "Neomaticos De Moto ( 19.78% )", "value": "19.78" },
    { "label": "Niveles ( 14.13% )", "value": "14.13" },
    { "label": "Olla ( 29.95% )", "value": "29.95" },
    { "label": "Olla Fredidora ( 49% )", "value": "49" },
    { "label": "Olla Para Cocion ( 24.3% )", "value": "24.3" },
    { "label": "Organetas ( 24.3% )", "value": "24.3" },
    { "label": "Osciloscopio ( 14.13% )", "value": "14.13" },
    { "label": "Oximetro ( 14.13% )", "value": "14.13" },
    { "label": "Palo De Piso ( 6% )", "value": "6" },
    { "label": "Palos De Golf ( 24.3% )", "value": "24.3" },
    { "label": "Panel De Control ( 24.3% )", "value": "24.3" },
    { "label": "Panel Solar  ( 13% )", "value": "13" },
    { "label": "Pantalla De Proyeccion ( 14.13% )", "value": "14.13" },
    { "label": "Pantalon ( 29.95% )", "value": "29.95" },
    { "label": "Panti ( 29.95% )", "value": "29.95" },
    { "label": "Panti Para Varices ( 14.13% )", "value": "14.13" },
    { "label": "Papel  ( 14.13% )", "value": "14.13" },
    { "label": "Papel Adhesivo ( 24.3% )", "value": "24.3" },
    { "label": "Papel Aluminio ( 32% )", "value": "32" },
    { "label": "Papel De Foto ( 14.13% )", "value": "14.13" },
    { "label": "Papel De Transferencia Termica ( 14.13% )", "value": "14.13" },
    { "label": "Papel Tapiz ( 24.3% )", "value": "24.3" },
    { "label": "Parabrisas ( 19.78% )", "value": "19.78" },
    { "label": "Parlantes Sin Caja ( 14.13% )", "value": "14.13" },
    { "label": "Parrila Para Carnes ( 24.3% )", "value": "24.3" },
    { "label": "Parte De Abanico ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Aire Acondicionado ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Arma Para Paintball ( 29.95% )", "value": "29.95" },
    { "label": "Parte De Asientos Para Carro ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Auricular ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Batidora ( 31.08% )", "value": "31.08" },
    { "label": "Parte De Bicicleta ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Caja De Cambios ( 42% )", "value": "42" },
    { "label": "Parte De Cajas De Cambio Nuevas ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Cajas De Cambio Usadas ( 55.92% )", "value": "55.92" },
    { "label": "Parte De Celular ( 13% )", "value": "13" },
    { "label": "Parte De Cierre Y Montura Para Puerta ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Clutch ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Cocina ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Cocina De Gas ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Distribuidor Para Carro  ( 42.38% )", "value": "42.38" },
    { "label": "Parte De Eje ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Equipo Medicion ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Freno De Carro ( 13% )", "value": "13" },
    { "label": "Parte De Freno Para Moto ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Frenos Para Carro ( 13% )", "value": "13" },
    { "label": "Parte De Griferia De Metal Cromado ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Griferia De Plastico Cromado ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Herramienta Electrica ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Herramienta Manual ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Impresora ( 13% )", "value": "13" },
    { "label": "Parte De Juguete ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Lampara ( 24.3% )", "value": "24.3" },
    { "label": "Parte De Laptop ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Lavadora ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Maquina De Coser  ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Microfono ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Moto ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Motor ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Mueble De Cualquier Material ( 19% )", "value": "19" },
    { "label": "Parte De Muebles ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Mufla ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Parlante ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Proyector  ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Radiador  ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Radio ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Rasuradora Electrica  ( 31.08% )", "value": "31.08" },
    { "label": "Parte De Refrigeracion ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Reloj ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Romana ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Sistema De Riego ( 19.78% )", "value": "19.78" },
    { "label": "Parte De Suspension ( 42.78% )", "value": "42.78" },
    { "label": "Parte De Tacometro  ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Taladro ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Telescopio  ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Troquel ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Tv ( 14.13% )", "value": "14.13" },
    { "label": "Parte De Valvula ( 14.13% )", "value": "14.13" },
    { "label": "Parte Para Lapicero ( 14.13% )", "value": "14.13" },
    { "label": "Parte Para Protesis ( 14.13% )", "value": "14.13" },
    { "label": "Parte Para Turbo De Carro ( 14.13% )", "value": "14.13" },
    { "label": "Parte Y Accesorio De Computadora ( 13% )", "value": "13" },
    { "label": "Parte Y Accesorio De Instrumentos Musicales ( 19% )", "value": "19" },
    { "label": "Partituras ( 6% )", "value": "6" },
    { "label": "Pasta Para Moldear ( 6% )", "value": "6" },
    { "label": "Patinetas ( 29.9% )", "value": "29.9" },
    { "label": "Pedal De Guitarra ( 19.78% )", "value": "19.78" },
    { "label": "Pegamento ( 29% )", "value": "29" },
    { "label": "Peine ( 29.95% )", "value": "29.95" },
    { "label": "Peluca ( 29.95% )", "value": "29.95" },
    { "label": "Peluche ( 29.95% )", "value": "29.95" },
    { "label": "Perfume ( 29.95% )", "value": "29.95" },
    { "label": "Pijama Algodon  ( 29.95% )", "value": "29.95" },
    { "label": "Pilot ( 29.95% )", "value": "29.95" },
    { "label": "Pinceles Para Maquillaje  ( 19.78% )", "value": "19.78" },
    { "label": "Pinceles Para Pintura ( 19.78% )", "value": "19.78" },
    { "label": "Pinturas  ( 24.3% )", "value": "24.3" },
    { "label": "Pipas ( 29.95% )", "value": "29.95" },
    { "label": "Piscina Inflable ( 24.3% )", "value": "24.3" },
    { "label": "Pistola Aerografica ( 14.13% )", "value": "14.13" },
    { "label": "Pistones ( 14.13% )", "value": "14.13" },
    { "label": "Pizarra ( 29.95% )", "value": "29.95" },
    { "label": "Placa Polarizada Adhesiva ( 14.13% )", "value": "14.13" },
    { "label": "Plancha De Imresion ( 14.13% )", "value": "14.13" },
    { "label": "Planchas Electricas Para Ropa ( 24.3% )", "value": "24.3" },
    { "label": "Plantilla Para Zapatos ( 19.78% )", "value": "19.78" },
    { "label": "Platillo Musical ( 24.3% )", "value": "24.3" },
    { "label": "Platos De Ceramica ( 29.95% )", "value": "29.95" },
    { "label": "Plumeros ( 29.95% )", "value": "29.95" },
    { "label": "Polea ( 14.13% )", "value": "14.13" },
    { "label": "Posters ( 29.95% )", "value": "29.95" },
    { "label": "Potenciometro ( 13% )", "value": "13" },
    { "label": "Prendedor De Ropa ( 14.13% )", "value": "14.13" },
    { "label": "Prensa De Carpinteria ( 14.13% )", "value": "14.13" },
    { "label": "Prensa De Papel Plasticas ( 29.95% )", "value": "29.95" },
    { "label": "Preparaciones De Limpieza ( 36.39% )", "value": "36.39" },
    { "label": "Procesador De Alimentos ( 49.27% )", "value": "49.27" },
    { "label": "Procesador Para Pc  ( 13% )", "value": "13" },
    { "label": "Propela Para Barco De Bronce ( 1% )", "value": "1" },
    { "label": "Prosesador Dealimentos Manual ( 14.13% )", "value": "14.13" },
    { "label": "Protector De Oido ( 14.13% )", "value": "14.13" },
    { "label": "Protesis ( 14.13% )", "value": "14.13" },
    { "label": "Protesis Ortopedicas ( 14.13% )", "value": "14.13" },
    { "label": "Proyector ( 13% )", "value": "13" },
    { "label": "Puerto Para Pc ( 13% )", "value": "13" },
    { "label": "Pulsera Para Reloj ( 24.3% )", "value": "24.3" },
    { "label": "Purificador ( 14.13% )", "value": "14.13" },
    { "label": "Rack Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Rack Para Tv ( 14.13% )", "value": "14.13" },
    { "label": "Radiador ( 42.78% )", "value": "42.78" },
    { "label": "Radio ( 49.27% )", "value": "49.27" },
    { "label": "Radios De Comunicacion ( 13% )", "value": "13" },
    { "label": "Rampa Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Raqueta ( 24.3% )", "value": "24.3" },
    { "label": "Rasuradoras Desechables ( 24.3% )", "value": "24.3" },
    { "label": "Rasuradoras Electricas ( 42.78% )", "value": "42.78" },
    { "label": "Red De Pesca ( 6% )", "value": "6" },
    { "label": "Refrigeradora Domestica ( 81.48% )", "value": "81.48" },
    { "label": "Registrador De Asistencia ( 14.13% )", "value": "14.13" },
    { "label": "Reglas ( 1% )", "value": "1" },
    { "label": "Regleta ( 13% )", "value": "13" },
    { "label": "Regulador Electrico ( 14.13% )", "value": "14.13" },
    { "label": "Relay ( 14.13% )", "value": "14.13" },
    { "label": "Reloj ( 29.95% )", "value": "29.95" },
    { "label": "Reproductor De Sonido ( 49% )", "value": "49" },
    { "label": "Repuesto De Moto ( 14.13% )", "value": "14.13" },
    { "label": "Repuesto Para Vehiculos ( 42.78% )", "value": "42.78" },
    { "label": "Resina Plastica ( 14.13% )", "value": "14.13" },
    { "label": "Resistencias ( 14.13% )", "value": "14.13" },
    { "label": "Resorte ( 14.13% )", "value": "14.13" },
    { "label": "Resorte De Carro ( 35.74% )", "value": "35.74" },
    { "label": "Retazos De Cuero ( 14.13% )", "value": "14.13" },
    { "label": "Retrovisor ( 14.13% )", "value": "14.13" },
    { "label": "Revista ( 1% )", "value": "1" },
    { "label": "Robot ( 14.13% )", "value": "14.13" },
    { "label": "Rodillo ( 29.95% )", "value": "29.95" },
    { "label": "Roles ( 14.13% )", "value": "14.13" },
    { "label": "Rollo De Pelicula Fotografica ( 24.3% )", "value": "24.3" },
    { "label": "Rollo De Tela  ( 24.3% )", "value": "24.3" },
    { "label": "Rollo Plastico ( 14.13% )", "value": "14.13" },
    { "label": "Romana ( 14.13% )", "value": "14.13" },
    { "label": "Rompecabezas  ( 29.95% )", "value": "29.95" },
    { "label": "Ropa ( 29.95% )", "value": "29.95" },
    { "label": "Ropa De Bebe ( 29.95% )", "value": "29.95" },
    { "label": "Ropa De Hombre ( 29.95% )", "value": "29.95" },
    { "label": "Ropa De Mujer ( 29.95% )", "value": "29.95" },
    { "label": "Rotulas ( 42.78% )", "value": "42.78" },
    { "label": "Rotulos ( 29.95% )", "value": "29.95" },
    { "label": "Router ( 13% )", "value": "13" },
    { "label": "Rueda Dentada ( 14.13% )", "value": "14.13" },
    { "label": "Ruedas De Coche De Bebe ( 14.13% )", "value": "14.13" },
    { "label": "Rulos ( 29.95% )", "value": "29.95" },
    { "label": "Sabanas ( 29.95% )", "value": "29.95" },
    { "label": "Sacacorchos ( 24.3% )", "value": "24.3" },
    { "label": "Sacapuntas ( 15% )", "value": "15" },
    { "label": "Saco De Vestir ( 29.95% )", "value": "29.95" },
    { "label": "Sandalias ( 29.95% )", "value": "29.95" },
    { "label": "Saxofon ( 24.3% )", "value": "24.3" },
    { "label": "Scanner Para Carro ( 13% )", "value": "13" },
    { "label": "Scanner Para Cmputadora ( 13% )", "value": "13" },
    { "label": "Secadora De Ropa ( 25.43% )", "value": "25.43" },
    { "label": "Secadora Pelo ( 49.27% )", "value": "49.27" },
    { "label": "Sellos  ( 29.95% )", "value": "29.95" },
    { "label": "Sensor De Oxigeno ( 13% )", "value": "13" },
    { "label": "Sensor Electtrico ( 14.13% )", "value": "14.13" },
    { "label": "Sensor Optico ( 14.13% )", "value": "14.13" },
    { "label": "Servilletas ( 29.95% )", "value": "29.95" },
    { "label": "Shampoo ( 49.27% )", "value": "49.27" },
    { "label": "Sierra Electrica ( 14.13% )", "value": "14.13" },
    { "label": "Silbato ( 24.3% )", "value": "24.3" },
    { "label": "Silicatos ( 14.13% )", "value": "14.13" },
    { "label": "Silla  ( 29.95% )", "value": "29.95" },
    { "label": "Silla De Bebe De Carro ( 13% )", "value": "13" },
    { "label": "Silla De Ruedas  ( 1% )", "value": "1" },
    { "label": "Sistema De Aire Acondicionado Para Casa ( 75.04% )", "value": "75.04" },
    { "label": "Sistema De Freno Para Moto ( 13% )", "value": "13" },
    { "label": "Sistema De Riego ( 14.13% )", "value": "14.13" },
    { "label": "Sleeping ( 29.95% )", "value": "29.95" },
    { "label": "Sobres ( 29.95% )", "value": "29.95" },
    { "label": "Software ( 14.13% )", "value": "14.13" },
    { "label": "Soldadura ( 14.13% )", "value": "14.13" },
    { "label": "Sombrero ( 29.95% )", "value": "29.95" },
    { "label": "Sombrilla ( 29.95% )", "value": "29.95" },
    { "label": "Suplemento Medico O Vitaminas ( 14.13% )", "value": "14.13" },
    { "label": "Suspension Bicicleta ( 19.78% )", "value": "19.78" },
    { "label": "Suspension Moto ( 19.78% )", "value": "19.78" },
    { "label": "Suspension Para Carro ( 42.78% )", "value": "42.78" },
    { "label": "Suspension Para Tractor ( 24.3% )", "value": "24.3" },
    { "label": "Switch ( 13% )", "value": "13" },
    { "label": "Tabaco ( 162.16% )", "value": "162.16" },
    { "label": "Tabla De Surf ( 24.3% )", "value": "24.3" },
    { "label": "Tableta Electronica ( 13% )", "value": "13" },
    { "label": "Tacometro ( 14.13% )", "value": "14.13" },
    { "label": "Taladro ( 14.13% )", "value": "14.13" },
    { "label": "Taladro Para Uso Dental ( 14.13% )", "value": "14.13" },
    { "label": "Tambor ( 24.3% )", "value": "24.3" },
    { "label": "Tapa De Caucho ( 19.78% )", "value": "19.78" },
    { "label": "Tapa De Distribuidor ( 42.38% )", "value": "42.38" },
    { "label": "Tapa Para Inodoro  ( 24.3% )", "value": "24.3" },
    { "label": "Tapa Plastica Tipo Rosca O No ( 14.13% )", "value": "14.13" },
    { "label": "Tapas Plasticas ( 24.3% )", "value": "24.3" },
    { "label": "Tapones De Corcho ( 14.13% )", "value": "14.13" },
    { "label": "Tarjeta De Circuitos ( 13% )", "value": "13" },
    { "label": "Tarjeta De Credito ( 13% )", "value": "13" },
    { "label": "Tarjeta De Memoria ( 13% )", "value": "13" },
    { "label": "Tarjeta Impresa ( 29.95% )", "value": "29.95" },
    { "label": "Tarjeta Impresa Plastica ( 19.78% )", "value": "19.78" },
    { "label": "Tarjeta Madre ( 13% )", "value": "13" },
    { "label": "Tarjetas Magneticas De Proximidad ( 13% )", "value": "13" },
    { "label": "Tazas De Ceramica ( 29.95% )", "value": "29.95" },
    { "label": "Teclado Musical ( 24.3% )", "value": "24.3" },
    { "label": "Teclado Para Computadora ( 13% )", "value": "13" },
    { "label": "Telefono De Casa ( 13% )", "value": "13" },
    { "label": "Telemetros ( 14.13% )", "value": "14.13" },
    { "label": "Telescopio ( 14.13% )", "value": "14.13" },
    { "label": "Televisor ( 49.27% )", "value": "49.27" },
    { "label": "Tenis ( 29.95% )", "value": "29.95" },
    { "label": "Teodolito ( 14.13% )", "value": "14.13" },
    { "label": "Termometro  ( 14.13% )", "value": "14.13" },
    { "label": "Termos  ( 24.3% )", "value": "24.3" },
    { "label": "Termostato ( 14.13% )", "value": "14.13" },
    { "label": "Tester ( 14.13% )", "value": "14.13" },
    { "label": "Tijeras ( 19.78% )", "value": "19.78" },
    { "label": "Timer ( 14.13% )", "value": "14.13" },
    { "label": "Tinta ( 14.13% )", "value": "14.13" },
    { "label": "Tinta Con Punta Para Lapicero ( 19.78% )", "value": "19.78" },
    { "label": "Tiquetes ( 29.9% )", "value": "29.9" },
    { "label": "Tiras De Plastico ( 19.78% )", "value": "19.78" },
    { "label": "Tizas ( 10% )", "value": "10" },
    { "label": "Toallas ( 29.95% )", "value": "29.95" },
    { "label": "Tocadisco ( 49.27% )", "value": "49.27" },
    { "label": "Toldo ( 29% )", "value": "29" },
    { "label": "Toma Corriente ( 13% )", "value": "13" },
    { "label": "Toner ( 14.13% )", "value": "14.13" },
    { "label": "Tornillos ( 19.78% )", "value": "19.78" },
    { "label": "Tostadora De Pan  ( 49.27% )", "value": "49.27" },
    { "label": "Traductor ( 13% )", "value": "13" },
    { "label": "Traje Entero ( 29.95% )", "value": "29.95" },
    { "label": "Trampas Para Animales ( 19.78% )", "value": "19.78" },
    { "label": "Transformador ( 14.13% )", "value": "14.13" },
    { "label": "Transistores ( 13% )", "value": "13" },
    { "label": "Tripode ( 14.13% )", "value": "14.13" },
    { "label": "Trituradora De Frutas Y Hortalizas  ( 49.27% )", "value": "49.27" },
    { "label": "Trofeo Estauillas ( 29.98% )", "value": "29.98" },
    { "label": "Tubo Aluminio Sin Trabajar ( 19.78% )", "value": "19.78" },
    { "label": "Tubo Aluminio Trabajado ( 24.3% )", "value": "24.3" },
    { "label": "Tubo De Hierro O Acero ( 14.13% )", "value": "14.13" },
    { "label": "Tubo Plastico ( 19.78% )", "value": "19.78" },
    { "label": "Tubos De Laboratorio ( 14.13% )", "value": "14.13" },
    { "label": "Tubos Fluorescentes Par Lampara ( 14.13% )", "value": "14.13" },
    { "label": "Tuercas ( 19.78% )", "value": "19.78" },
    { "label": "Turbo Para Carro ( 14.13% )", "value": "14.13" },
    { "label": "Unidad Cd ( 13% )", "value": "13" },
    { "label": "Unidad Dvd ( 13% )", "value": "13" },
    { "label": "Vajilla De Carton ( 29.95% )", "value": "29.95" },
    { "label": "Vajilla De Ceramica ( 29.95% )", "value": "29.95" },
    { "label": "Vajilla De Plastico ( 29.95% )", "value": "29.95" },
    { "label": "Valvulas ( 14.13% )", "value": "14.13" },
    { "label": "Vaporizador De Limpieza ( 14.13% )", "value": "14.13" },
    { "label": "Varilla De Soldadura ( 14.13% )", "value": "14.13" },
    { "label": "Vaso De Vidrio ( 29.95% )", "value": "29.95" },
    { "label": "Vaso Termico ( 24.3% )", "value": "24.3" },
    { "label": "Vestido ( 29.95% )", "value": "29.95" },
    { "label": "Video Monitor ( 49.27% )", "value": "49.27" },
    { "label": "Video Proyector ( 49.27% )", "value": "49.27" },
    { "label": "Violin ( 24.3% )", "value": "24.3" },
    { "label": "Volante Repuesto Para Tractores ( 24.3% )", "value": "24.3" },
    { "label": "Winch ( 24.3% )", "value": "24.3" },
    { "label": "Zapatos ( 29.95% )", "value": "29.95" },
    { "label": "Zapatos De Hombre ( 29.95% )", "value": "29.95" },
    { "label": "Zapatos De Mujer ( 29.95% )", "value": "29.95" }
]